export const blogs = [
  {
    "category": "Khám phá",
    "title": "Nguồn gốc và lịch sử của matcha Nhật Bản",
    "summary": "Tìm hiểu về hành trình matcha từ trà đạo Nhật Bản đến toàn cầu",
    "slug": "nguon-goc-va-lich-su-cua-matcha-nhat-ban",
    "thumbnailUrl": "https://thoidaicoffee.vn/wp-content/uploads/2024/08/tim-hieu-ve-matcha-la-gi-nguon-goc-lich-su-phan-loai-va-cach-nhan-biet-4-700x393.webp",
    "author": "Duong Duy",
    "content": [
      {
        "content": "Matcha bắt nguồn từ Nhật Bản vào thế kỷ 12, được sử dụng trong trà đạo.",
        "image": "https://example.com/images/matcha-history.jpg"
      },
      {
        "content": "Quy trình sản xuất matcha đòi hỏi sự tỉ mỉ, từ che nắng đến xay bột.",
        "image": "https://example.com/images/matcha-process.jpg"
      }
    ],
    "teawares": [
      {
        "name": "Chawan (bát trà)",
        "image": "https://example.com/images/chawan.jpg"
      },
      {
        "name": "Chasen (chổi tre)",
        "image": "https://example.com/images/chasen.jpg"
      }
    ],
    "ingredients": [],
    "directions": [],
    "createdAt": "2025-06-06T22:32:00.000Z",
    "updatedAt": "2025-06-06T22:32:00.000Z"
  },
  {
    "category": "Khám phá",
    "title": "Văn hóa trà đạo matcha ở Kyoto",
    "summary": "Khám phá nghệ thuật trà đạo matcha tại cố đô Nhật Bản",
    "slug": "van-hoa-tra-dao-matcha-o-kyoto",
    "thumbnailUrl": "https://suntravelgroup.vn/media/3974/tra-dao-3.jpg",
    "author": "Duong Duy",
    "content": [
      {
        "content": "Kyoto là trung tâm của trà đạo, nơi matcha được tôn vinh.",
        "image": "https://example.com/images/kyoto-tea.jpg"
      },
      {
        "content": "Nghi thức trà đạo thể hiện sự tĩnh lặng và tôn trọng.",
        "image": "https://example.com/images/tea-ceremony.jpg"
      }
    ],
    "teawares": [
      {
        "name": "Chawan truyền thống",
        "image": "https://example.com/images/chawan-kyoto.jpg"
      }
    ],
    "ingredients": [],
    "directions": [],
    "createdAt": "2025-06-06T22:32:00.000Z",
    "updatedAt": "2025-06-06T22:32:00.000Z"
  },
  {
    "category": "Khám phá",
    "title": "Matcha và thiền: Sự kết nối tâm linh",
    "summary": "Tìm hiểu cách matcha hỗ trợ thiền định và tĩnh tâm",
    "slug": "matcha-va-thien-su-ket-noi-tam-linh",
    "thumbnailUrl": "https://hoithankinhhocvietnam.com.vn/vnna-media/24/8/30/uong-matcha-co-mat-ngu-khong--su-dung-nhu-the-nao.jpg",
    "author": "Duong Duy",
    "content": [
      {
        "content": "Matcha được các thiền sư sử dụng để tăng cường sự tập trung.",
        "image": "https://example.com/images/zen-matcha.jpg"
      },
      {
        "content": "Uống matcha trước thiền giúp tâm trí tỉnh táo và bình an.",
        "image": "https://example.com/images/meditation.jpg"
      }
    ],
    "teawares": [
      {
        "name": "Bát trà thiền",
        "image": "https://example.com/images/zen-bowl.jpg"
      }
    ],
    "ingredients": [],
    "directions": [],
    "createdAt": "2025-06-06T22:32:00.000Z",
    "updatedAt": "2025-06-06T22:32:00.000Z"
  },
  {
    "category": "Làm đẹp",
    "title": "Mặt nạ matcha giúp làm sáng da",
    "summary": "Cách làm mặt nạ matcha tự nhiên cho làn da rạng rỡ",
    "slug": "mat-na-matcha-giup-lam-sang-da",
    "thumbnailUrl": "https://cdn.nhathuoclongchau.com.vn/unsafe/https://cms-prod.s3-sgn09.fptcloud.com/cong_dung_cua_mat_na_tra_xanh_1_e482112677.jpg",
    "author": "Duong Duy",
    "content": [
      {
        "content": "Matcha chứa chất chống oxy hóa giúp làm sáng và bảo vệ da.",
        "image": "https://example.com/images/matcha-benefits.jpg"
      },
      {
        "content": "Kết hợp matcha với mật ong và sữa chua để tạo mặt nạ dưỡng da.",
        "image": "https://example.com/images/mask-recipe.jpg"
      }
    ],
    "teawares": [],
    "ingredients": [
      {
        "ingredient": ["Bột matcha", "Mật ong", "Sữa chua"],
        "image": "https://example.com/images/mask-ingredients.jpg"
      }
    ],
    "directions": [
      {
        "step": "Trộn 1 muỗng bột matcha với 1 muỗng mật ong và 2 muỗng sữa chua.",
        "image": "https://example.com/images/mask-step1.jpg"
      },
      {
        "step": "Đắp hỗn hợp lên mặt trong 15 phút, sau đó rửa sạch.",
        "image": "https://example.com/images/mask-step2.jpg"
      }
    ],
    "createdAt": "2025-06-06T22:32:00.000Z",
    "updatedAt": "2025-06-06T22:32:00.000Z"
  },
  {
    "category": "Làm đẹp",
    "title": "Matcha trong chăm sóc tóc tự nhiên",
    "summary": "Sử dụng matcha để nuôi dưỡng tóc chắc khỏe và bóng mượt",
    "slug": "matcha-trong-cham-soc-toc-tu-nhien",
    "thumbnailUrl": "http://file.hstatic.net/1000135323/article/toc1.jpg",
    "author": "Duong Duy",
    "content": [
      {
        "content": "Matcha giúp kích thích mọc tóc nhờ các chất chống oxy hóa.",
        "image": "https://example.com/images/hair-benefits.jpg"
      },
      {
        "content": "Kết hợp matcha với dầu dừa để tạo mặt nạ tóc tự nhiên.",
        "image": "https://example.com/images/hair-mask.jpg"
      }
    ],
    "teawares": [],
    "ingredients": [
      {
        "ingredient": ["Bột matcha", "Dầu dừa"],
        "image": "https://example.com/images/hair-ingredients.jpg"
      }
    ],
    "directions": [
      {
        "step": "Trộn 1 muỗng matcha với 2 muỗng dầu dừa ấm.",
        "image": "https://example.com/images/hair-step1.jpg"
      },
      {
        "step": "Thoa hỗn hợp lên tóc, ủ trong 30 phút rồi gội sạch.",
        "image": "https://example.com/images/hair-step2.jpg"
      }
    ],
    "createdAt": "2025-06-06T22:32:00.000Z",
    "updatedAt": "2025-06-06T22:32:00.000Z"
  },
  {
    "category": "Làm đẹp",
    "title": "Tẩy tế bào chết với matcha và đường",
    "summary": "Công thức tẩy tế bào chết tự nhiên với matcha cho làn da mịn màng",
    "slug": "tay-te-bao-chet-voi-matcha-va-duong",
    "thumbnailUrl": "https://file.hstatic.net/200000591917/file/chia-se-3-cach-tay-te-bao-chet-bang-bot-tra-xanh-vo-cung-hieu-qua__2__e77551f7ef7043b0acd08e0a525d31e6_grande.jpg",
    "author": "Duong Duy",
    "content": [
      {
        "content": "Matcha giúp làm sạch da, kết hợp đường để tẩy tế bào chết hiệu quả.",
        "image": "https://example.com/images/scrub-benefits.jpg"
      },
      {
        "content": "Hỗn hợp matcha và đường nhẹ nhàng làm sạch lỗ chân lông.",
        "image": "https://example.com/images/scrub-recipe.jpg"
      }
    ],
    "teawares": [],
    "ingredients": [
      {
        "ingredient": ["Bột matcha", "Đường nâu", "Dầu ô liu"],
        "image": "https://example.com/images/scrub-ingredients.jpg"
      }
    ],
    "directions": [
      {
        "step": "Trộn 1 muỗng matcha, 2 muỗng đường nâu, và 1 muỗng dầu ô liu.",
        "image": "https://example.com/images/scrub-step1.jpg"
      },
      {
        "step": "Massage hỗn hợp lên da ướt, sau đó rửa sạch.",
        "image": "https://example.com/images/scrub-step2.jpg"
      }
    ],
    "createdAt": "2025-06-06T22:32:00.000Z",
    "updatedAt": "2025-06-06T22:32:00.000Z"
  },
  {
    "category": "Pha chế",
    "title": "Cách pha latte matcha chuẩn vị",
    "summary": "Hướng dẫn pha latte matcha thơm ngon, béo ngậy tại nhà",
    "slug": "cach-pha-latte-matcha-chuan-vi",
    "thumbnailUrl": "https://i.pinimg.com/736x/57/15/f7/5715f7671707d2cefd112bdabc226c6c.jpg",
    "author": "Duong Duy",
    "content": [
      {
        "content": "Latte matcha là sự kết hợp hoàn hảo giữa matcha và sữa.",
        "image": "https://example.com/images/latte-intro.jpg"
      },
      {
        "content": "Sử dụng matcha chất lượng cao để có hương vị tốt nhất.",
        "image": "https://example.com/images/latte-tips.jpg"
      }
    ],
    "teawares": [
      {
        "name": "Chasen",
        "image": "https://example.com/images/chasen-latte.jpg"
      },
      {
        "name": "Cốc latte",
        "image": "https://example.com/images/latte-cup.jpg"
      }
    ],
    "ingredients": [
      {
        "ingredient": ["Bột matcha", "Sữa tươi", "Đường"],
        "image": "https://example.com/images/latte-ingredients.jpg"
      }
    ],
    "directions": [
      {
        "step": "Đánh tan 1 muỗng matcha với 50ml nước nóng bằng chasen.",
        "image": "https://example.com/images/latte-step1.jpg"
      },
      {
        "step": "Đun nóng 150ml sữa tươi, thêm đường, đổ matcha vào và khuấy đều.",
        "image": "https://example.com/images/latte-step2.jpg"
      }
    ],
    "createdAt": "2025-06-06T22:32:00.000Z",
    "updatedAt": "2025-06-06T22:32:00.000Z"
  },
  {
    "category": "Pha chế",
    "title": "Matcha smoothie giải nhiệt mùa hè",
    "summary": "Công thức matcha smoothie tươi mát, dễ làm cho ngày nóng",
    "slug": "matcha-smoothie-giai-nhiet-mua-he",
    "thumbnailUrl": "https://i.pinimg.com/736x/7d/80/aa/7d80aa7063e5d151e8a7818941586f33.jpg",
    "author": "Duong Duy",
    "content": [
      {
        "content": "Matcha smoothie kết hợp vị trà xanh và trái cây tươi mát.",
        "image": "https://example.com/images/smoothie-intro.jpg"
      },
      {
        "content": "Dùng máy xay sinh tố để có kết cấu mịn màng.",
        "image": "https://example.com/images/smoothie-tips.jpg"
      }
    ],
    "teawares": [
      {
        "name": "Máy xay sinh tố",
        "image": "https://example.com/images/blender.jpg"
      },
      {
        "name": "Ly cao",
        "image": "https://example.com/images/tall-glass.jpg"
      }
    ],
    "ingredients": [
      {
        "ingredient": ["Bột matcha", "Chuối", "Sữa hạnh nhân", "Mật ong"],
        "image": "https://example.com/images/smoothie-ingredients.jpg"
      }
    ],
    "directions": [
      {
        "step": "Xay 1 muỗng matcha, 1 quả chuối, 200ml sữa hạnh nhân, 1 muỗng mật ong.",
        "image": "https://example.com/images/smoothie-step1.jpg"
      },
      {
        "step": "Đổ ra ly, thêm đá và thưởng thức ngay.",
        "image": "https://example.com/images/smoothie-step2.jpg"
      }
    ],
    "createdAt": "2025-06-06T22:32:00.000Z",
    "updatedAt": "2025-06-06T22:32:00.000Z"
  },
  {
    "category": "Pha chế",
    "title": "Matcha soda sảng khoái",
    "summary": "Cách làm matcha soda mát lạnh, dễ uống cho mọi dịp",
    "slug": "matcha-soda-sang-khoai",
    "thumbnailUrl": "https://i.pinimg.com/736x/28/bb/16/28bb160aa35547151161d1f42b00967d.jpg",
    "author": "Duong Duy",
    "content": [
      {
        "content": "Matcha soda là thức uống lý tưởng cho ngày hè.",
        "image": "https://example.com/images/soda-intro.jpg"
      },
      {
        "content": "Kết hợp matcha với soda và chanh để có vị tươi mới.",
        "image": "https://example.com/images/soda-tips.jpg"
      }
    ],
    "teawares": [
      {
        "name": "Ly thủy tinh",
        "image": "https://example.com/images/glass-soda.jpg"
      }
    ],
    "ingredients": [
      {
        "ingredient": ["Bột matcha", "Nước soda", "Nước cốt chanh", "Đường"],
        "image": "https://example.com/images/soda-ingredients.jpg"
      }
    ],
    "directions": [
      {
        "step": "Hòa tan 1 muỗng matcha với 50ml nước nóng và 1 muỗng đường.",
        "image": "https://example.com/images/soda-step1.jpg"
      },
      {
        "step": "Đổ matcha vào ly đá, thêm nước cốt chanh và soda, khuấy nhẹ.",
        "image": "https://example.com/images/soda-step2.jpg"
      }
    ],
    "createdAt": "2025-06-06T22:32:00.000Z",
    "updatedAt": "2025-06-06T22:32:00.000Z"
  }
];